
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcRadialBarChart as ObcRadialBarChartElement} from '@oicl/openbridge-webcomponents/dist/bars-graphs/radial-bar-chart/radial-bar-chart.js';
 
 
 

 
 export const ObcRadialBarChart = createComponent({
   react: React,
   tagName: 'obc-radial-bar-chart',
   elementClass: ObcRadialBarChartElement,
   events: {
     
   }
  });
 
 